import React from 'react';
import ComboBox from '@pb/kit-component-combo-box';
import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './styles.module.styl';

import type {SwitcherTypesProps} from '../typedef';


const classNames = withCssModule(styles);

export const ShowResults = (props: SwitcherTypesProps) => {
    const {
        children,
        comboBoxProps,
        disabled,
        onChangePages,
        showSizeSwitcher,
        state,
    } = props;

    const {pageSize} = state;

    const captionTransform = (caption: string) => `Show ${caption || pageSize} Results`;

    return showSizeSwitcher ? (
        <ComboBox
            aria-label="Show results"
            {...{
                disabled,
                captionTransform,
                value: pageSize,
                onChange: onChangePages,
                ...comboBoxProps,
            }}
            className={classNames('show-results-combobox', comboBoxProps?.className)}>
            {children}
        </ComboBox>
    ) : null;
};
